/* eslint-disable react-refresh/only-export-components */
'use client'

import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'
import { cn } from '@eigtech/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'

// Define input size variants
const textareaVariants = cva(
  `border-input text-foreground placeholder:text-muted-foreground/80 focus-visible:border-ring focus-visible:ring-ring/30 aria-invalid:border-destructive aria-invalid:ring-destructive/10 dark:aria-invalid:border-destructive dark:aria-invalid:ring-destructive/20 shadow-xs [[readonly]]:opacity-70 w-full border bg-transparent shadow-black/5 transition-[color,box-shadow] focus-visible:outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50`,
  {
    variants: {
      variant: {
        sm: 'rounded-md px-2.5 py-2.5 text-xs',
        md: 'rounded-md px-3 py-3 text-sm',
        lg: 'rounded-md px-4 py-4 text-sm',
      },
    },
    defaultVariants: {
      variant: 'md',
    },
  }
)

function Textarea({
  className,
  variant,
  render,
  rows = 5,
  ...props
}: useRender.ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>) {
  const element = useRender({
    render,
    defaultTagName: 'textarea',
    props: mergeProps(
      {
        className: cn(textareaVariants({ variant }), className),
        rows,
      },
      props
    ),
    state: {
      slot: 'textarea',
    },
  })

  return element
}

export { Textarea, textareaVariants }
